import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './globals.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
)

declare global {
    interface Window {
        gtag: (command: string, action: string, params?: Record<string, any>) => void
    }
}
